"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingQueue = void 0;
class PendingQueue {
    constructor() {
        this._tasks = [];
        this._doInterval = () => {
            if (this._tasks.length) {
                this._tasks.forEach((task) => task());
                this._tasks = [];
            }
        };
        setInterval(this._doInterval, 500);
    }
    push(task) {
        this._tasks.push(task);
    }
}
exports.PendingQueue = PendingQueue;
PendingQueue.instance = new PendingQueue();
